module.exports = __webpack_public_path__ + "img/1-3-p3.482fabbd.svg";